export default {
  title: 'Haluatko varmasti poistaa tilisi?',
  description:
    'Tämä toimenpide on pysyvä. Menetät pääsyn tilauksiisi, kanta-asiakaspisteisiisi ja tallennettuihin asetuksiisi.',
  labels: {
    loading: 'Poistetaan tiliäsi...',
  },
  buttons: {
    confirm: 'Vahvista',
    cancel: 'Peruuta',
  },
  toasts: {
    success:
      'Tilisi on poistettu pysyvästi. Sinulla ei ole enää pääsyä tilaushistoriaasi, kanta-asiakaspisteisiisi tai tallennettuihin tietoihisi.',
    error: 'Jokin meni pieleen. Yritä uudelleen. Jos ongelma jatkuu, ota yhteyttä tukitiimiimme: {{supportEmail}}',
  },
};
